import axios from 'axios'

import { tagCrmError } from '../utils/error-message'

const GronerWrapper = {
  postToGroner: (subdomain, endpoint, payload) => {
    return new Promise((resolve, reject) => {
      const url = `https://${subdomain}.api.safeleads.app/api/${endpoint}`
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      return axios.post(url, payload, config).then(({ data }) => {
        return resolve(data)
      }).catch(err => {
        return reject(tagCrmError(err))
      })
    })
  },
  getToken: (subdomain, email, password) => {
    return new Promise((resolve, reject) => {
      const payload = {
        email,
        senha: password
      }
      return GronerWrapper.postToGroner(
        subdomain,
        'Conta/GerarToken',
        payload
      ).then(({ Content }) => {
        const { accessToken, created, expiration, funcao, nome, perfil, perfilid, usuarioid } = Content
        return resolve({ accessToken, created, expiration, funcao, nome, perfil, perfilid, usuarioid })
      }).catch(err => {
        return reject(tagCrmError(err))
      })
    })
  }
}

export default GronerWrapper



// WEBPACK FOOTER //
// ./src/services/groner-wrapper.js